const BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

const getHeaders = () => {
  const token = localStorage.getItem('token')
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }
}

export const useApi = () => {
  const get = async (path) => {
    const res = await fetch(`${BASE_URL}${path}`, { headers: getHeaders() })
    return res.json()
  }

  const post = async (path, body) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(body),
    })
    return res.json()
  }

  const put = async (path, body) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(body),
    })
    return res.json()
  }

  const patch = async (path, body) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: 'PATCH',
      headers: getHeaders(),
      body: JSON.stringify(body),
    })
    return res.json()
  }

  const del = async (path) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: 'DELETE',
      headers: getHeaders(),
    })
    return res.json()
  }

  return { get, post, put, patch, del }
}
